//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import * as React from "react";
import { getServiceContext } from "~base/Services/ConsilioServiceContext";
import { getSettingsContext } from "~base/Settings/ConsilioSettingsContext";
import { getSoPIntlContext } from "~irad/Internationalization/SoPIntlContext";
import { getSoPValidationContext } from "~irad/Validation/SoPValidationContext";
import { getSoPNormalizerContext } from "~irad/Validation/SoPNormalizerContext";
import { guideServiceMock } from "~base/Services/Guide/IGuideService";
import { ContextWrapper } from "~base/ContextWrapper";
import SoPTheme from "~irad/Styling/SoPConsilioTheme";
import { defaultConfig } from "~base/Internationalization/ConfigurationInfo";
import MainRouter from "./MainRoutes";
import * as textCodeService from "~base/Services/TextCodeService";
import { ErrorBoundary } from "~base/Pages/Shared/ErrorBoundary";

type MainProps = {
    children?: React.ReactNode;
};

//-------------------------------------------------------------------------------------
// Component
//-------------------------------------------------------------------------------------

const MainApp: React.FunctionComponent<MainProps> = (props: MainProps) => {
    return (
        <ContextWrapper
            {...props}
            theme={SoPTheme}
            getServiceContext={getServiceContext}
            getSettingsContext={getSettingsContext}
            guide={guideServiceMock}
            useScreenSharing={false}
            messages={textCodeService.textCodes()}
            getIntlContext={getSoPIntlContext}
            useServerContext={true}
            loadUser={true}
            useUsersPreferredCulture={true}
            currency={"SEK"}
            compatMode={false}
            config={defaultConfig}
            getValidationContext={getSoPValidationContext}
            getNormalizerContext={getSoPNormalizerContext}
            intl={null}
            validation={null}
        >
            <ErrorBoundary catchJsErrors={true} catchPromiseErrors={true}>
                <MainRouter />
            </ErrorBoundary>
        </ContextWrapper>
    );
};

export default MainApp;
